export type Creator = {
  id?: number;
  address?: string;
  name?: string;
  image?: string;
};

export type ContractSpec = 'erc721' | 'erc1155';
export type ValidationTypes = 0 | 1 | 2 | 3; // INVALID, CONTRACT, RANGE, MERKLE_TREE
export type TokenSpecs = 0 | 1 | 2; // INVALID, ERC721, ERC1155
export type BurnSpecs = 0 | 1 | 2; // NONE, MANIFOLD, OPENZEPPELIN

export type BurnItemFromInstance = {
  validationType: ValidationTypes;
  contractAddress: string;
  tokenSpec: number;
  burnSpec: number;
  amount: number;
  minTokenId: string; // uint256
  maxTokenId: string; // uint256
  merkleRoot: string; // a merkle root hash bytes32
  /**
   * @dev: the following data is only on the web2 instance and NOT on chain
   */
  tokenIds?: string[]; // array of token IDs that form the merkle root hash
  contractName?: string; // for display in the UX
  contractSymbol?: string; // for display in the UX
};

export type BurnGroupFromInstance = {
  requiredCount: number; // uint256
  items: BurnItemFromInstance[];
};

export type BurnSetFromInstance = BurnGroupFromInstance[];

export type BurnRedeemPublicData = {
  network?: number;
  image?: string;
  name: string;
  description: string;
  extensionAddress: string;
  redeemContractAddress: string;
  burnSet?: BurnSetFromInstance;
  burnIndex: number;
  // ux optimization vars
  redeemAssetMedia?: string;
  redeemAssetThumbnail?: string;
  redeemTokenName?: string;
};

export class BurnRedeemStudioInstance {
  id: string;
  userId: string;
  slug: string;
  creator?: Creator;
  publicData: BurnRedeemPublicData;

  constructor(
    id: string,
    userId: string,
    slug: string,
    creator: Creator,
    publicData: BurnRedeemPublicData,
  ) {
    this.id = id;
    this.userId = userId;
    this.slug = slug;
    this.creator = creator;
    this.publicData = publicData;
  }
  static fromJson(data: Record<string, unknown>): BurnRedeemStudioInstance {
    const publicData = data.publicData as Record<string, unknown>;

    return new BurnRedeemStudioInstance(
      data.id as string,
      data.userId as string,
      data.slug as string,
      data.creator as Creator,
      publicData as BurnRedeemPublicData,
    );
  }
}
